import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --primary: #2C3E50;
    --secondary: #F39C12;
    --accent: #E67E22;
    --light: #ECF0F1;
    --dark: #1A252F;
    --gray: #95A5A6;
    --success: #27AE60;
    --danger: #E74C3C;
    --white: #FFFFFF;
    --black: #000000;
    
    --font-primary: 'Montserrat', sans-serif;
    --font-secondary: 'Lora', serif;
    
    --shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.1);
    --shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);
    --shadow-lg: 0 10px 20px rgba(0, 0, 0, 0.15);
    
    --transition: all 0.3s ease-in-out;
    
    --container-width: 1200px;
    --header-height: 80px;
    --mobile-header-height: 60px; /* Added mobile header height */
    --footer-height: 300px;
    --sidebar-width: 280px;
    
    --border-radius-sm: 4px;
    --border-radius-md: 8px;
    --border-radius-lg: 12px;
  }
  
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: var(--font-primary);
    color: var(--dark);
    background-color: var(--white);
    line-height: 1.5;
    overflow-x: hidden;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: var(--font-secondary);
    font-weight: 700;
    line-height: 1.3;
    margin-bottom: 1rem;
  }
  
  h1 {
    font-size: 2.5rem;
  }
  
  h2 {
    font-size: 2rem;
  }
  
  h3 {
    font-size: 1.75rem;
  }
  
  h4 {
    font-size: 1.5rem;
  }
  
  h5 {
    font-size: 1.25rem;
  }
  
  h6 {
    font-size: 1rem;
  }
  
  p {
    margin-bottom: 1rem;
  }
  
  a {
    color: var(--primary);
    text-decoration: none;
    transition: var(--transition);
    
    &:hover {
      color: var(--accent);
    }
  }
  
  ul, ol {
    list-style: none;
  }
  
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
  
  button, input, textarea, select {
    font-family: inherit;
    font-size: inherit;
    outline: none;
  }
  
  button {
    cursor: pointer;
    border: none;
    background: none;
  }
  
  .container {
    width: 100%;
    max-width: var(--container-width);
    margin: 0 auto;
    padding: 0 1.5rem;
  }
  
  section {
    padding: 5rem 0;
  }
  
  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
    
    section {
      padding: 3rem 0;
    }
  }
`;

export default GlobalStyles;